<script lang="ts">
	// see https://glidejs.com/
	import Glide, {
		Swipe,
		Breakpoints,
		Controls,
		Autoplay
	} from '@glidejs/glide/dist/glide.modular.esm';
	import DynamicComponent from '../../components/DynamicComponent.svelte';
	import { attrValue } from '$lib/utils/html';

	enum positionControlsEnmu {
		TOP = 'top',
		BOTTOM = 'bottom'
	}

	type positionTypeControls = 'top' | 'bottom';
	export let sliderClassNames: string = null;
	export let trackClassNames: string = null;
	export let slidesClassNames: string = null;
	export let slideClassNames: string = null;
	export let config = {};
	export let swipe = false;
	export let breakpoints = false;
	export let controls = false;
	export let autoplay = false;
	export let slider = null;
	export let slides;
	export let fade = false;
	export let spin = false;
	export let positionControls: positionTypeControls = 'top';

	if (spin)
		config = {
			startAt: 1,
			type: 'carousel',
			gap: 0,
			perView: 3
		};

	const init = (node: HTMLElement) => {
		slider = new Glide(node, config);
		let modules = {};
		controls && (modules = { ...modules, Controls });
		swipe && (modules = { ...modules, Swipe });
		breakpoints && (modules = { ...modules, Breakpoints });
		autoplay && (modules = { ...modules, Autoplay });
		slider.mount(modules);
	};
</script>

<div class={attrValue(['glide', sliderClassNames])} use:init class:fade class:spin>
	{#if positionControls === positionControlsEnmu.TOP}
		<slot name="controls" />
	{/if}
	<div class={attrValue(['glide__track', trackClassNames])} data-glide-el="track">
		<ul class={attrValue(['glide__slides', slidesClassNames])}>
			{#if slides}
				{#each slides as slide}
					<li class={attrValue(['glide__slide', slideClassNames])}>
						<DynamicComponent component={slide} />
					</li>
				{/each}
				<slot name="extra-slide" />
			{/if}
		</ul>
	</div>
	{#if positionControls === positionControlsEnmu.BOTTOM}
		<slot name="controls" />
	{/if}
</div>

<style lang="postcss">
	@import '@glidejs/glide/dist/css/glide.core.min.css';
	div :global(.glide__slide) {
		height: auto !important;
	}
	.fade {
		& :global(.glide__slides) {
			transform: none !important;
			width: auto !important;
			display: block;
			height: 100% !important;
		}
		& :global(.glide__slide) {
			position: absolute;
			left: 0;
			top: 0;
			opacity: 0;
			transition: opacity 0.3s;
			width: 100% !important;
			height: 100% !important;
			margin-right: 0 !important;
			margin-left: 0 !important;
		}
		& :global(.glide__slide--active) {
			z-index: 1;
			opacity: 1 !important;
		}
	}
	.spin {
		& :global(.glide__slides) {
			transform: none !important;
			width: auto !important;
			@apply grid justify-center;
		}
		:global(.glide__slide) {
			@apply flex h-full row-start-1 col-start-1 lg:!w-[270px] xl:!w-[310px] 2xl:!w-[350px];
			flex-shrink: 0;
			scale: 0.8;
			opacity: 0;
			transition:
				scale 0.5s ease,
				opacity 0.3s ease,
				translate 0.7s 0.2s ease;
		}
		:global(.glide__slide .card > a) {
			@apply lg:!h-[100px] xl:!h-[200px] 2xl:!h-[238px];
		}
		:global(.glide__slide--active) {
			opacity: 1;
			scale: 1;
			z-index: 2;
		}
		:global(.glide__slide--active + li) {
			scale: 0.9;
			opacity: 1;
			translate: 105%;
			transition:
				opacity 0.5s 0.5s ease,
				scale 0.3s 0.5s ease,
				translate 0.7s 0s ease;
		}
		:global(*:has(+ .glide__slide--active)) {
			scale: 0.9;
			opacity: 1;
			translate: -105%;
			transition:
				opacity 0.5s 0.2s ease,
				scale 0.3s ease,
				translate 0.7s 0s ease;
		}
	}
</style>
